/* Oxalis — horizontal product carousel ("Nos nouveautés" and friends).
   Native overflow-x scroll handles trackpad + touch; this adds discreet
   desktop prev/next arrows, arrow visibility at the ends, and gentle
   mouse-wheel -> horizontal translation (without trapping the page scroll). */
(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-fp-track]');
    var prev = root.querySelector('[data-fp-prev]');
    var next = root.querySelector('[data-fp-next]');
    if (!track) return;

    function step() {
      // scroll by roughly one "page" of visible cells
      return Math.max(track.clientWidth * 0.85, 240);
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= maxScroll;
      var overflowing = track.scrollWidth > track.clientWidth + 2;
      if (prev) prev.hidden = atStart || !overflowing;
      if (next) next.hidden = atEnd || !overflowing;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    });
    window.addEventListener('resize', updateArrows);

    // Mouse wheel -> horizontal, but let the page keep scrolling at the edges.
    track.addEventListener(
      'wheel',
      function (e) {
        if (e.deltaY === 0 || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var next = track.scrollLeft + e.deltaY;
        if (next <= 0 || next >= maxScroll) return; // at an edge: don't trap
        e.preventDefault();
        track.scrollLeft = next;
      },
      { passive: false }
    );

    updateArrows();
    // re-check once images have loaded (scrollWidth can change)
    window.setTimeout(updateArrows, 300);
  }

  document.querySelectorAll('[data-fp-carousel]').forEach(initCarousel);
})();
